export function getSubdomainFranchise(): string {
  if (typeof window === 'undefined') {
    console.log('No window object found, returning default subdomain');
    return 'matriz';
  }
  
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0]
  return subdomain != 'xdoinfinitto' && subdomain != 'localhost' ? subdomain : 'matriz';
}
